import { darkColors, lightColors, fireColors } from "../../theme/colors";
import { AlertTheme } from "./types";

export const light: AlertTheme = {
  background: lightColors.backgroundAlt,
};

export const dark: AlertTheme = {
  background: darkColors.backgroundAlt,
};

export const fire: AlertTheme = {
  background: fireColors.backgroundAlt,
};
